exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__searchBar___fOzPy{max-width:400px;position:relative;width:100%}.styles__searchBar___fOzPy input{font-weight:600;padding:0 2.5rem}.styles__searchBar___fOzPy input::placeholder{font-weight:400}.styles__searchBar___fOzPy svg{fill:#8c9ba5;height:1rem;left:.75rem;position:absolute;top:calc(50% - .5rem);width:1rem;z-index:2}", ""]);

// Exports
exports.locals = {
	"searchBar": "styles__searchBar___fOzPy"
};